/**
 * Return an object from an item retrieved by the API
 * @param {Object} APIItem
 * @return {x, y, year} description
 */
const getDefaultMapDataFromAPIItem = (
  APIItem,
  xKeys = ['section_x'],
  yKeys = ['section_y'],
  namePrefix = ''
) => {
  let mapData
  const firstNameKey = 'first_name'
  const nameKey = 'name'
  if (APIItem) {
    let year = APIItem.begin_year
    let date = APIItem.begin_date
    if (date) year = new Date(date).getFullYear()
    let xKey = ''
    let yKey = ''
    // find which key is better for displaying lat lng
    xKeys.forEach((currentXKey, index) => {
      if (APIItem[currentXKey] !== '') {
        xKey = currentXKey
        yKey = yKeys[index]
      }
    })

    if (xKey === '') {
      xKey = xKeys[xKeys.length - 1]
      yKey = yKeys[yKeys.length - 1]
    }
    const name = APIItem[namePrefix + firstNameKey] !== undefined
      ? (APIItem[namePrefix + firstNameKey] !== ''
        ? (APIItem[namePrefix + firstNameKey] + ' ' + (APIItem[namePrefix + nameKey] !== '' ? APIItem[namePrefix + nameKey] : ''))
        : APIItem[namePrefix + nameKey])
      : ''

    mapData = {
      x: APIItem[xKey],
      y: APIItem[yKey],
      year,
      name,
      id_exhibition: APIItem.id_exhibition
    }
  }
  return mapData
}

const getMapDataForExhibition = (APIItem, index) => {
  let mapData
  if (APIItem) {
    mapData = getDefaultMapDataFromAPIItem(APIItem, ['section_x'], ['section_y'])
    const city = APIItem.city || APIItem.exhibition_city

    mapData.popup = `<div class="exhibition_item" data-index="${index}" data-id="${APIItem.id_exhibition}">
      <span class="date" title="Date">${mapData.year}</span>
      <span title="Ville" class="city">${city}</span>
      ${APIItem.space ? `<span class="space" title="Lieu">, ${APIItem.space}</span>` : ''}
      ${APIItem.exhibition_title ? `<span class="exhibition-title" title="Titre de l'exposition">, ${APIItem.exhibition_title}</span>` : ''}
      ${APIItem.title ? `<span class="exhibited-work-title" title="Titre de l'œuvre">, ${APIItem.title}</span>` : ''}
      ${mapData.name ? `<span class="exhibitor-name" title="Prénom, Nom">, ${mapData.name}</span>` : ''}
      ${APIItem.section_title ? `<span class="section_title" title="Section"> - Section : ${APIItem.section_title}</span>` : ''}
    </div>`
  }
  return mapData
}

const getMapDataForExhibitorHome = (APIItem, index, prefix) => {
  let mapData
  if (APIItem) {
    mapData = getDefaultMapDataFromAPIItem(APIItem, ['address_x'], ['address_y'], prefix)
    mapData.popup = `<div class="exhibitor--home_item" data-index="${index}" data-id="${APIItem.id}">
      <span class="name" title="Name">${mapData.name}</span>
      <span title="Ville" class="city">${APIItem.address}</span>
    </div>`
  }
  return mapData
}

const getMapDataForExhibitorBirth = (APIItem, index, prefix) => {
  let mapData
  if (APIItem) {
    mapData = getDefaultMapDataFromAPIItem(APIItem, ['x_address_b', 'x_city_b'], ['y_address_b', 'y_city_b'], prefix)
    const date = (
      APIItem.month_b && APIItem.month_b !== 0
      ? (APIItem.day_b && APIItem.day_b !== 0
        ? `${APIItem.day_b}/`
        : '') + `${APIItem.month_b}/`
      : '') +
      (APIItem.year_b && APIItem.year_b !== 0 ? APIItem.year_b : '')

    mapData.popup = `<div class="exhibitor--birth_item" data-index="${index}" data-id="${APIItem.id_exhibition}">
      <span class="name" title="Name">${mapData.name}</span>
      <span class="date" title="Date">${date}</span>
      <span title="Ville" class="city">${APIItem.city_b}</span>
      ${APIItem.birth_address ? `<span class="space" title="Lieu">, ${APIItem.birth_address}</span>` : ''}
      </div>`
  }
  return mapData
}

const getMapDataForExhibitorDeath = (APIItem, index, prefix) => {
  let mapData
  if (APIItem) {
    mapData = getDefaultMapDataFromAPIItem(APIItem, ['x_address_d', 'x_city_d'], ['y_address_d', 'y_city_d'], prefix)
    const date = (
      APIItem.month_d && APIItem.month_d !== 0
        ? (APIItem.day_d && APIItem.day_d !== 0
          ? `${APIItem.day_d}/`
          : '') + `${APIItem.month_d}/`
        : '') +
      (APIItem.year_d && APIItem.year_d !== 0 ? APIItem.year_d : '')
    mapData.popup = `<div class="exhibitor--death_item" data-index="${index}" data-id="${APIItem.id_exhibition}">
      <span class="name" title="Name">${mapData.name}</span>
      <span class="date" title="Date">${date}</span>
      <span title="Ville" class="city">${APIItem.city_d}</span>
      ${APIItem.death_address ? `<span class="space" title="Lieu">, ${APIItem.death_address}</span>` : ''}
    </div>`
  }
  return mapData
}

const getMapDataForExhibitedWorkOwner = (APIItem, index) => {
  let mapData
  if (APIItem) {
    mapData = getDefaultMapDataFromAPIItem(APIItem, ['x_city_o'], ['y_city_o'])
    mapData.popup = `<div class="exhibitedwork--owner_item" data-index="${index}" data-id="${APIItem.id_exhibition}">
      ${APIItem.title ? `<span class="exhibited-work-title" title="Titre de l'œuvre">${APIItem.title}</span>` : ''}
      ${APIItem.owner ? `<span class="exhibited-work-owner" title="Propriétaire de l'œuvre">${APIItem.owner}</span>` : ''}
      <span title="Ville" class="city">${APIItem.city_o}</span>
    </div>`
  }
  return mapData
}

const getMapDataForExhibitedWorkCreation = (APIItem, index) => {
  let mapData
  if (APIItem) {
    mapData = getDefaultMapDataFromAPIItem(APIItem, ['x_city_c'], ['y_city_c'])
    mapData.popup = `<div class="exhibitedwork--creation_item" data-index="${index}" data-id="${APIItem.id_exhibition}">
      ${APIItem.title ? `<span class="exhibited-work-title" title="Titre de l'œuvre">${APIItem.title}</span>` : ''}
      <span title="Ville" class="city">${APIItem.city_c}</span>
    </div>`
  }
  return mapData
}

export const getMapDataFromExhibitor = function (exhibitorData = []) {
  const result = [{
    layer: 'exhibition',
    color: 'blue',
    data: [],
    arrayOfLatLngs: []
  }, {
    layer: 'home',
    color: 'red',
    data: [],
    arrayOfLatLngs: []
  }, {
    layer: 'birth',
    color: 'green',
    data: [],
    arrayOfLatLngs: []
  }, {
    layer: 'death',
    color: 'purple',
    data: [],
    arrayOfLatLngs: []
  }]
  exhibitorData.forEach((currentData, index) => {
    let mapData = getMapDataForExhibition(currentData, index)
    result[0].data.push(mapData)
    if (mapData.x) {
      result[0].arrayOfLatLngs.push([mapData.y, mapData.x])
    }
    mapData = getMapDataForExhibitorHome(currentData, index)
    result[1].data.push(mapData)
    if (mapData.x) {
      result[1].arrayOfLatLngs.push([mapData.y, mapData.x])
    }
    mapData = getMapDataForExhibitorBirth(currentData, index)
    result[2].data.push(mapData)
    if (mapData.x) {
      result[2].arrayOfLatLngs.push([mapData.y, mapData.x])
    }
    mapData = getMapDataForExhibitorDeath(currentData, index)
    result[3].data.push(mapData)
    if (mapData.x) {
      result[3].arrayOfLatLngs.push([mapData.y, mapData.x])
    }
  })
  return result
}

export const getMapDataFromExhibition = function (exhibitionData = []) {
  const result = [{
    layer: 'exhibition',
    color: 'blue',
    data: [],
    arrayOfLatLngs: []
  }]
  exhibitionData.forEach((currentData, index) => {
    let mapData = getMapDataForExhibition(currentData, index)
    result[0].data.push(mapData)
    if (mapData.x) {
      result[0].arrayOfLatLngs.push([mapData.y, mapData.x])
    }
  })
  return result
}

export const getMapDataFromExhibitedWork = function (exhibitedWorkData = []) {
  const result = [{
    layer: 'exhibition',
    color: 'blue',
    data: [],
    arrayOfLatLngs: []
  }, {
    layer: 'home', // artist home
    color: 'red',
    data: [],
    arrayOfLatLngs: []
  }, {
    layer: 'birth', // artist birth
    color: 'green',
    data: [],
    arrayOfLatLngs: []
  }, {
    layer: 'death', // artist death
    color: 'purple',
    data: [],
    arrayOfLatLngs: []
  }, {
    layer: 'owner', // owner place
    color: 'orange',
    data: [],
    arrayOfLatLngs: []
  }, {
    layer: 'creation', // creation place
    color: 'yellow',
    data: [],
    arrayOfLatLngs: []
  }]
  exhibitedWorkData.forEach((currentData, index) => {
    let mapData = getMapDataForExhibition(currentData, index)
    result[0].data.push(mapData)
    if (mapData.x) {
      result[0].arrayOfLatLngs.push([mapData.y, mapData.x])
    }
    mapData = getMapDataForExhibitorHome(currentData, index, 'exhibitor_')
    result[1].data.push(mapData)
    if (mapData.x) {
      result[1].arrayOfLatLngs.push([mapData.y, mapData.x])
    }
    mapData = getMapDataForExhibitorBirth(currentData, index, 'exhibitor_')
    result[2].data.push(mapData)
    if (mapData.x) {
      result[2].arrayOfLatLngs.push([mapData.y, mapData.x])
    }
    mapData = getMapDataForExhibitorDeath(currentData, index, 'exhibitor_')
    result[3].data.push(mapData)
    if (mapData.x) {
      result[3].arrayOfLatLngs.push([mapData.y, mapData.x])
    }
    mapData = getMapDataForExhibitedWorkOwner(currentData, index)
    result[4].data.push(mapData)
    if (mapData.x) {
      result[4].arrayOfLatLngs.push([mapData.y, mapData.x])
    }
    mapData = getMapDataForExhibitedWorkCreation(currentData, index)
    result[5].data.push(mapData)
    if (mapData.x) {
      result[5].arrayOfLatLngs.push([mapData.y, mapData.x])
    }
  })
  return result
}



// WEBPACK FOOTER //
// ./src/store/search/resultmap.helper.js